import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Loader from "../Loader/Loader";
import { getFAQ } from "../Common/apis";

const faqData = [
  {
    question: "What is GISUL and how does it help students?",
    answer:
      "GISUL is a next-generation learning and assessment platform dedicated to empowering students for government exams, defence recruitment, and career advancement. With structured learning paths, mock tests, and expert mentorship, GISUL bridges the gap between preparation and success."
  },
  {
    question: "Which exams can I prepare for on GISUL?",
    answer:
      "GISUL provides preparation modules for Defence (Army, Navy, Air Force), SSC, Railway, Banking, and various State-level exams. Our content is regularly updated as per the latest syllabus and exam patterns."
  },
  {
    question: "What makes GISUL different from other platforms?",
    answer:
      "Unlike traditional platforms, GISUL offers a personalized learning experience powered by AI-based performance tracking, region-wise mock tests, instant feedback, and expert-curated study material — all under one roof."
  },
  {
    question: "How do I enroll in a course or test series on GISUL?",
    answer:
      "You can sign up for free on the GISUL website. Once logged in, explore available courses or test packages, and proceed to enroll through our secure payment gateway."
  },
  {
    question: "Is GISUL suitable for students from rural areas?",
    answer:
      "Yes, GISUL is designed with accessibility in mind. Our platform is lightweight, mobile-friendly, and available in both English and Hindi to support learners from all regions, especially rural and semi-urban areas."
  },
  {
    question: "Are the tests available in Hindi as well?",
    answer:
      "Absolutely. All major tests on GISUL are available in both Hindi and English to cater to diverse learners and maintain inclusivity."
  },
  {
    question: "Can I access GISUL content on my mobile phone?",
    answer:
      "Yes, GISUL is fully responsive and can be accessed on smartphones, tablets, and desktops. Our Android app will be launching soon for an even smoother experience."
  },
  {
    question: "What support does GISUL offer if I face a problem?",
    answer:
      "We have a dedicated student support team available 24/7. You can contact us via email at support@gisul.in or through the help section in your dashboard."
  },
  {
    question: "Is my data safe on GISUL?",
    answer:
      "Yes, GISUL follows strict data protection policies. Your personal and academic information is securely encrypted and never shared with third parties."
  },
  {
    question: "Does GISUL offer career counseling or mentorship?",
    answer:
      "Yes, GISUL provides access to expert mentors for doubt resolution, career guidance, and motivational sessions to keep you on the right track during your preparation."
  }
];

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getFAQ()
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <div className="main-div">
        <Navbar />
        {loading && <Loader />}
        <div className="xl:pt-[140px] lg:pt-[100px] md:pt-[80px] pt-[50px] xl:px-[100px] lg:px-[40px] px-[20px] pb-[50px]">
          <div className="bg-[#FFFFFF] p-[30px] rounded-[16px] border-[1px] border-[#A1A1A1] w-full">
            <h2 className="font-[700] text-[32px] md:text-[40px] text-[#1D1837] mb-[30px]">
              Frequently Asked Questions
            </h2>
            <div className="flex flex-col gap-4">
              {data && data.length>0 && data.map((faq, index) => (
                <div
                  key={index}
                  className="bg-[#E4E9FD] rounded-[10px] p-[20px] cursor-pointer"
                >
                  <div
                    onClick={() => toggleFAQ(index)}
                    className="flex justify-between items-center"
                  >
                    <h4 className="font-[600] text-[18px] md:text-[20px] text-[#000]">
                      {faq.question}
                    </h4>
                    <span className="text-[24px]">
                      {activeIndex === index ? "-" : "+"}
                    </span>
                  </div>
                  {activeIndex === index && (
                    <p className="text-[#4F5576] pt-[10px] text-[14px] md:text-[16px]">
                      {faq.answer}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Faq;
